import orgApi from './apis.js'
import response from 'fe-coms/utils/response'
import Vue from '@/app.js'

const http = new Vue().$http

const action = {
  // 获取缓存区域
  getOrgAll ({commit, state}) {
    if (state.promiseStatus) {
      return
    }
    return new Promise((resolve, reject) => {
      let api = orgApi.initTree
      commit('SET_ORG_TREE_LOADING', true)
      commit('SET_ORG_PROMISE_STATUS', 'pending')
      response(http(api.type, api.url, { withRoot: 0 })).then((result) => {
        if (result.isOk && result.content) {
          let data = result.content.orgTree || []
          commit('SET_ORG_TREE_DATA', data)
        }
        commit('SET_ORG_TREE_LOADING', false)
        commit('SET_ORG_PROMISE_STATUS', 'resolve')
        resolve(result)
      }).catch(error => {
        commit('SET_ORG_TREE_LOADING', false)
        commit('SET_ORG_PROMISE_STATUS', 'reject')
        reject(error)
      })
    })
  }
}

export default action
